import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WinRT } from '@lenovo/tan-client-bridge-le';
import { FeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';

@Component({
	selector: 'vtr-widget-feedback',
	templateUrl: './widget-feedback.component.html',
	styleUrls: ['./widget-feedback.component.scss'],
})
export class WidgetFeedbackComponent implements OnInit {
	@Output() visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public isFeedbackVisible: boolean = true;

	constructor(private featureToggle: FeatureToggleService) {}

	ngOnInit(): void {
		this.checkVisibility();
	}

	public openFeedback() {
		WinRT.launchUri('https://feedback.uds.lenovo.com/commercial-vantage');
	}

	private checkVisibility() {
		const isGiveFeedbackFeatureToggleAvailable = !!this.featureToggle.isFeatureAvailable(
			FeatureToggle.GiveFeedback
		);

		if (this.isFeedbackVisible !== isGiveFeedbackFeatureToggleAvailable) {
			this.isFeedbackVisible = isGiveFeedbackFeatureToggleAvailable;
			this.visibilityChange.emit(this.isFeedbackVisible);
		}
	}
}
